import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';

@Component({
    selector: 'cmps-coaching-bl-document',
    template: ` <iframe class="cmps-coaching-bl-document--iframe"></iframe>`,
    host: {
        class: 'cmps-coaching-bl-document',
    },
})
export class DocumentComponent implements AfterViewInit {
    @Input()
    get html(): string {
        return this._html;
    }

    set html(value: string) {
        this._html = value;
        this._reload();
    }

    /** @private */
    _html: string;

    private _root: HTMLIFrameElement;

    constructor(private readonly _el: ElementRef<HTMLElement>) {}

    ngAfterViewInit(): void {
        this._root = this._el.nativeElement.querySelector('iframe');
        this._reload();
    }

    private _reload(): void {
        if (this._root == null) {
            return;
        }
        /* if this doesn't work out try a dedicated api endpoint to return an actual page */
        const blob = new Blob([this._html], { type: 'text/html' });
        this._root.src = URL.createObjectURL(blob);
    }
}
